// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_D-z","hovered":"aE-z","hoverImage":"bE-z","mainImage":"cE-z","imageNoBackground":"dE-z","fullSizeImage":"eE-z"};